/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Created On: March 23rd, 2018
 * Last Modified: March 23rd, 2018
 * ****************************************************************************
 */
import * as React from 'react';
import * as Mui from 'mui';
import * as history from 'history';
import { match as Match } from 'react-router-dom';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { Toolbar } from './components/toolbar';
import { PlayChess } from '../playChess';
import { SetupGameView } from '../setupGame';
import { AppEvents } from 'contexts/appEventsContext';

/** HomeProps - Properties */
export interface HomeProps {
  history: history.History;
  location: Location;
  match: Match<{}>;
  events: AppEvents;
}

/** HomeState - State */
export interface HomeState {
  popup: boolean;
  unsubscribe?: () => void;
}

/** Home */
export class Home extends React.Component<HomeProps, HomeState> {
  constructor(props: HomeProps, ctx: any) {
    super(props, ctx);
    this.state = {
      popup: false,
    };
  }

  componentDidMount() {
    const subscriptions = [
      this.props.events.onMenuDefault('new-game', this.onNewGame)
    ];

    this.setState({
      unsubscribe: () => { subscriptions.forEach(fn => fn()); }
    });
  }

  componentWillUnmount() {
    if (this.state.unsubscribe) {
      this.state.unsubscribe();
    }
  }

  readonly onNewGame = () => {
    this.props.history.push('/setup/start');
  }

  readonly expSetup = /^\/setup/;

  render() {
    const base = (pth?: string) => '/' + (pth || '');

    const isSetup = this.expSetup.test(this.props.location.pathname);

    return (
      <div id="home" className="home column">
        <Toolbar history={this.props.history} buttonType={isSetup ? 'play' : 'new'}></Toolbar>
        <div id="content" className="content">
          <div id="backdrop"></div>
          <div id="page-area">
            <Router history={this.props.history} >
              <Switch>
                <Redirect exact from={base()} to={base('setup/')} />
                <Route path={base('setup/')} component={SetupGameView} />
                <Route path={base('play/')} component={PlayChess} />
                <Redirect from={base('**')} to={base()} />
              </Switch>
            </Router>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/views/home/index.tsx